import { ThemeTonalRange } from '@philips-emr/tws-constants';
import { FileService } from '@philips-emr/tws-core/lib/services';
import DefaultFileHandler from '@philips-emr/tws-core/lib/services/file/default-file-handler';
import FileHandlerConfiguration from '@philips-emr/tws-core/lib/services/file/file-handler-configuration';

import { Endpoint } from '../constants';

export interface ConfigurationDataProps {
  [key: string]: boolean | string | number | object;
}

class ProviderAccreditationConfigurationService {

  private static configurationData: Promise<ConfigurationDataProps>;
  private static tonalRange: ThemeTonalRange;

  static getConfigurationData(): Promise<ConfigurationDataProps> {
    return this.configurationData;
  }

  static setConfigurationData(config: Promise<ConfigurationDataProps>): void {
    this.configurationData = config;
  }

  static setFileuploaderConfig(): void {
    const config = new FileHandlerConfiguration();
    config.uploadUrl = Endpoint.POST.UPLOAD_FILE;
    config.previewUrl = Endpoint.GET.PREVIEW_FILE;
    config.removeUrl = Endpoint.DELETE.REMOVE_FILE;

    const handler = new DefaultFileHandler();
    handler.setConfiguration(config);

    FileService.setFileHandler(handler);
  }

  static getTonalidadeLogin(): ThemeTonalRange {
    return this.tonalRange;
  }

  static setTonalidadeLogin(tonalRange: ThemeTonalRange): void {
    this.tonalRange = tonalRange;
  }
}

export {
  ProviderAccreditationConfigurationService,
};
